<div
  class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center"
>
  <div
    class="bg-white rounded-2xl max-h-[90vh] w-[800px] 2xl:w-[1000px] 3xl:w-[1200px] 4xl:w-[1400px] flex flex-col overflow-hidden"
  >
    <!-- Title and X -->
    <div class="flex-none flex items-center justify-between px-4">
      <h1 class="my-4 pl-2 text-dimot-1 text-[0.84rem] xl:text-[1.03rem] 2xl:text-[1.07rem] text-center">
        {{
          regionName === "Prov. Aut. di Bolzano"
            ? "PA di Bolzano"
            : regionName === "Prov. Aut. di Trento"
              ? "PA di Trento"
              : regionName
        }} - {{ regionPercentage }} %
      </h1>
      <button (click)="oncloseModal(false)">
        <svg
          class="mr-[7px] w-4 h-4 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6 cursor-pointer"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
            fill="#141F58"
          />
        </svg>
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="flex justify-center items-center h-40">
      <div
        class="flex items-center space-x-4 text-center text-2xl font-semibold"
      >
        <div
          class="w-10 h-10 border-4 border-t-transparent border-gray-600 rounded-full animate-spin"
        ></div>
      </div>
    </div>

    <!-- No data -->
    <ng-container *ngIf="!isLoading && isDataEmpty">
      <div class="flex-none border-y border-gray-200">
        <table class="w-full table-fixed">
          <thead>
            <tr
              class="bg-tableHead h-[40px] xl:h-[45px] 2xl:h-[50px] text-[0.5rem] xl:text-[0.55rem] 2xl:text-[0.62rem] 3xl:text-[0.67rem] text-gray-700"
            >
              <th class="w-[24%] text-start pl-[28px]">OSPEDALE</th>
              <th class="w-[12%] text-center">CITTÀ</th>
              <th class="w-[16%] text-center">TIPOLOGIA</th>
              <th class="w-[16%] text-center">ESPERIENZE #</th>
              <th class="w-[16%] text-center">APERTURA IN ECONOMIA</th>
              <th class="w-[16%] text-center">DATA DI FORECAST</th>
              <th class="w-[16%] text-center">DATA DI ACTUAL</th>
            </tr>
          </thead>
        </table>
      </div>

      <div class="relative flex-1 min-h-[250px] xl:min-h-[300px] 2xl:min-h-[350px]">
        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
          <p class="text-gray-400 font-medium text-[0.6rem] xl:text-[0.7rem] 2xl:text-[0.75rem] bg-sky-100 px-4 py-2 rounded-sm mb-5">
            Non ci sono dati da mostrare
          </p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading && !isDataEmpty">
      <!-- HEADER - fuori dallo scroll -->
      <div class="flex-none border-y border-gray-200">
        <table class="w-full table-fixed">
          <thead>
            <tr
              class="bg-tableHead h-[40px] xl:h-[45px] 2xl:h-[50px] text-[0.5rem] xl:text-[0.55rem] 2xl:text-[0.62rem] 3xl:text-[0.67rem] text-gray-700"
            >
              <th class="w-[24%] text-start pl-[28px]">OSPEDALE</th>
              <th class="w-[12%] text-center">CITTÀ</th>
              <th class="w-[16%] text-center">TIPOLOGIA</th>
              <th class="w-[16%] text-center">ESPERIENZE #</th>
              <th class="w-[16%] text-center">APERTURA IN ECONOMIA</th>
              <th class="w-[16%] text-center">DATA DI FORECAST</th>
              <th class="w-[16%] text-center">DATA DI ACTUAL</th>
            </tr>
          </thead>
        </table>
      </div>

      <!-- BODY - scrollabile -->
      <div
        class="relative flex-1 overflow-y-auto scrollbar2 min-h-[420px] max-h-[470px] 3xl:max-h-[600px] mb-3"
      >
        <table class="w-full table-fixed text-center">
          <colgroup>
            <col class="w-[24%]" />
            <col class="w-[12%]" />
            <col class="w-[16%]" />
            <col class="w-[16%]" />
            <col class="w-[16%]" />
            <col class="w-[16%]" />
          </colgroup>
          <tbody>
            <tr
              *ngFor="let item of hospitalList"
              class="text-[0.8rem] h-10 xl:h-12 2xl:h-14 text-dimot-1 border-b border-gray-100"
            >
              <td
                class="text-start pl-[28px] text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem] w-[24%]"
              >
                {{ item.name | hospitalTitlecase }}
              </td>
              <td class="w-[12%] text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem]">
                {{ item.city | titlecase }}
              </td>
              <td class="w-[16%] text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem]">
                {{ item.accountType | tipologiaFormat }}
              </td>
              <td class="w-[16%] text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem]">
                {{ item.potentialNumber }}
              </td>
              <td class="w-[16%]">
                <span
                  *ngIf="
                    item.status === 'Open' &&
                    item.accountType.toLowerCase() !== 'non prescrittore'
                  "
                  class="text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem] px-2.5 py-0.5 rounded-sm inline-flex items-center bg-green-100 text-green-800"
                >
                  Aperto
                </span>
                <span
                  *ngIf="
                    item.status === 'Closed' &&
                    item.accountType.toLowerCase() !== 'non prescrittore'
                  "
                  class="text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem] px-2.5 py-0.5 rounded-sm inline-flex items-center bg-red-100 text-red-800"
                >
                  Chiuso
                </span>
                <span
                  *ngIf="item.accountType.toLowerCase() === 'non prescrittore'"
                  class="text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem] px-2.5 py-0.5 rounded-sm inline-flex items-center bg-sky-100 text-sky-800"
                >
                  Non Prescrittore
                </span>
              </td>
              <td class="w-[16%] text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem]">
                {{ item.dueDate | customDateFormat }}
              </td>
              <td class="w-[16%] text-[0.53rem] xl:text-[0.6rem] 2xl:text-[0.65rem] 3xl:text-[0.7rem]">
                {{ item.endDate | customDateFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>